import { isNewRelicEnabled } from './newRelicConfig';

/** Syncs logged-in user context to NR when the browser agent is fully enabled. */
export function applyNewRelicUserContext(loginResponse) {
  if (!isNewRelicEnabled()) return;

  const nr = window.newrelic;
  if (!nr) return;

  if (loginResponse?.userId) {
    nr.setUserId?.(loginResponse.userId);
  }
  if (loginResponse?.role) {
    nr.setCustomAttribute?.('user.role', loginResponse.role, true);
  }
}
